import { Span } from 'themes/jumbo/@jumbo/shared';
import {
  Avatar,
  Chip,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import { ProjectType } from './types';
import { getCachedData } from "api/Cache";
import { useHistory } from 'react-router-dom';
import { formatDate } from "services/UtilsService";
import { ReactComponent as DefaultImage } from './icon-earth.svg';


const ProjectItem = ({ item }: {item:ProjectType}) => {
  const { ID:projectID, name:projectName = 'Unknown Project', description:projectDescription = '', image = '', thumbnail = '', timezone, file_date:creationDate = '' } = item;
  const data: any = getCachedData();
  var views = data["views"];
  const projectViews = Object.values(views)
    .filter((view: any) => view.project === projectID)
      .sort((a:any, b:any) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
  const viewsImages: any[] = projectViews.filter((view: any) => view.has_thumbnail === "1" && view.thumb);
  let projectImage;

  if (viewsImages.length && !(image || thumbnail)) {
    projectImage = viewsImages[0].thumb;
  }
  const history = useHistory();
  const handleClick = (e: any) => {
      history.push(`/catalog/${projectID}`);
  };

  return (
    <ListItemButton
      component={'li'}
      sx={{
        //p: (theme) => theme.spacing(1.25, 3),
        p: '12px 24px',
        transition: 'all 0.2s',

        '&:hover': {
          //boxShadow: `rgba(0, 0, 0, 0.2) 0px 3px 2px 0px`,
          //transform: 'translateY(-4px)',
        },
      }}
      onClick={handleClick}
    >
      <ListItemAvatar sx={{ minWidth: {xs: 45, sm:45, md:55, lg:55, xl:55} }}>
        <Avatar
          alt={projectName}
          src={projectImage}
          sx={{ width: {xs: '35px', sm:'35px', md:'45px', lg:'45px', xl:'45px'}, height: {xs: '35px', sm:'35px', md:'45px', lg:'45px', xl:'45px'} }}
        >
          {!projectImage ? <DefaultImage /> : ""}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography variant={'h5'} mb={0.5} className='listItemTitle'>
            {projectName}
          </Typography>
        }
        secondary={
          <Typography variant={'h6'} mb={0.5} color={'text.secondary'} style={{fontSize: '13px'}}>
            {projectDescription}
          </Typography>
        }
        sx={{ width:'50%' }}
      />
      <ListItemText
        primary={
          <Typography variant={'h6'} color={'text.secondary'} style={{fontSize: '13px', margin: 0}}>
            {creationDate ? formatDate(creationDate) : "---"}
          </Typography>
        }
        sx={{pl: '25px', display: {xs: 'none', sm:'none', md:'flex', lg:'flex', xl:'flex'}}}
      />
      <Chip
        size={'small'}
        label={`${projectViews.length} view(s)`}
        sx={{
          transform: 'scale(.9)',
          textAlign: 'center',
          display: {xs: 'none', sm:'none', md:'flex', lg:'flex', xl:'flex'},
          borderRadius: '4px'
        }}
      />
    </ListItemButton>
  );
};

export { ProjectItem };
